<template>
    <v-ons-page>
        <div v-show="loading" class="page-progress-loader">
            <v-ons-progress-circular
                indeterminate
                ></v-ons-progress-circular>
        </div>
        <v-ons-list v-show="!loading" modifier="noborder" class="form">
            <v-ons-list-item modifier="nodivider">
                <label for="email">New Password</label>
                <v-ons-input
                    input-id="password"
                    placeholder=""
                    v-model="profile.password"
                    type="password"
                    ></v-ons-input>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
                <label for="password">Confirm Password</label>
                <v-ons-input
                    input-id="confirmPassword"
                    placeholder=""
                    v-model="profile.confirmPassword"
                    type="password"
                    ></v-ons-input>
                    <p class="form-text">Min 8 characters, one UPPERCASE letter and one number.</p>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
                <button type="submit"
                    @click="save"
                    class="button button--primary">
                    Save
                </button>
                 <v-ons-button
                    @click="$router.push({ name: 'home' })"
                    modifier="cta">
                    Cancel
                </v-ons-button>
            </v-ons-list-item>
        </v-ons-list>
    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import Module from './mixins/Module'

export default {
    data() {
        return {
            loading: false,
            profile: {
                password: '',
                confirmPassword: '',
            }
        }
    },

    created() {
        this.$emit('init', {
            name: 'change-password',
            title: 'Change Password',
            showMenu: true,
        })

        if (!this.login.content.id) {
            return this.$router.push('login')
        }
    },

    mixins: [
        Utils,
        Module('login'),
    ],

    methods: {
        save() {
            if (!this.profile.password) {
                return this.notification_push({
                    type: 'error',
                    message: 'Please enter your new password',
                })
            }

            if (this.profile.password !== this.profile.confirmPassword) {
                return this.notification_push({
                    type: 'error',
                    message: 'Confirm password does not match',
                })
            }

            this.login.changePath('/my/password')
            this.loading = true
            this.login.updateData({
                data: this.profile,
                options: {
                    throwError: true,
                }
            }).then(() => {
                this.profile.password = ''
                this.profile.confirmPassword = ''
                this.notification_push({
                    type: 'success',
                    message: 'Your password has been updated',
                })
            }).catch((err) => {
                this.notification_push({
                    type: 'error',
                    message: _.get(err, 'response.data.message', 'Cannot update your password'),
                })
            }).finally(() => {
                this.loading = false
            })
        }
    }
};
</script>

<style scoped>
.form{
    padding-top: 12px;
}
.right-icon {
  margin-left: 10px;
}
.right-label {
  color: #666;
}
ons-input {
    width: 100%;
}
.float-right {
    float: right;
}
.list-item{
    padding: 0 14px;
    padding-top: 0;
    padding-bottom: 0;
}
.form-buttons{
    margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue